import { configureStore } from "@reduxjs/toolkit"
import schedulesReducer from "../features/schedules/slice"
import scheduledObservationsReducer from "../features/scheduled-observations/slice"
import observationsReducer from "../features/observations/slice"
import collectionsReducer from "../features/collections/slice"
import rsoReducer from "../features/rsos/slice"
import astrositesReducer from "../features/astrosites/slice"
import settingsReducer from "../features/settings/slice"
import samplesReducer from "../features/samples/slice"
import submissionsReducer from "../features/data-submissions/slice"
import dashboardReducer from "../features/dashboard/slice"
import passesReducer from "../features/passes/slice"
import prioritiesReducer from "../features/priorities/slice"
import playlistsReducer from "../features/playlists/slice"
import iamReducer from "../features/iam/slice"
import actionReducer from "../features/audit/slice"
import timelapsesReducer from "../features/timelapses/slice"

import { DateTime } from "luxon"

export const store = configureStore({
  reducer: {
    schedules: schedulesReducer,
    observations: observationsReducer,
    collections: collectionsReducer,
    rsos: rsoReducer,
    astrosites: astrositesReducer,
    settings: settingsReducer,
    scheduledObservations: scheduledObservationsReducer,
    samples: samplesReducer,
    submissions: submissionsReducer,
    dashboard: dashboardReducer,
    passes: passesReducer,
    priorities: prioritiesReducer,
    playlists: playlistsReducer,
    iam: iamReducer,
    actions: actionReducer,
    timelapses: timelapsesReducer,
  },
})

export const allowUpdate = (currentISODateTime, incomingISODateTime) => {
  // We are permissive so if either date is undefined we cant compare and allow the update
  if (!currentISODateTime || !incomingISODateTime) {
    return true
  }
  const oldUpdated = DateTime.fromISO(currentISODateTime)
  const newUpdated = DateTime.fromISO(incomingISODateTime)
  return oldUpdated < newUpdated
}
